<template>
  <section>
    <carousel-vertical :images="images">
      <template v-slot:header>
        <span v-if="step.attributes.hint || step.attributes.hint_image.url" class="pl-3">
          <b-tooltip
            type="is-light"
            :triggers="['click']"
            :auto-close="['outside', 'escape']"
            multilined
            size="is-large"
          >
            <template v-slot:content>
              <div class="has-text-centered">
                <div class="pt-3 is-size-6">{{ step.attributes.hint }}</div>
                <div v-if="step.attributes.hint_image.url" class="p-3 m-3">
                  <figure class="image is-inline-block">
                    <img
                      style="border-radius: 5%"
                      :src="step.attributes.hint_image.url"
                      alt="Hint image"
                    />
                  </figure>
                </div>
                <div v-else class="pb-3"></div>
              </div>
            </template>
            <a><b-icon type="is-gold" icon="comment-alert-outline"></b-icon></a>
          </b-tooltip>
        </span>
        <span v-else class="pl-3">
          <b-icon type="is-gray" icon="comment-alert-outline"></b-icon>
        </span>

        <span v-if="step.attributes.epic_fail || step.attributes.epic_fail_image.url">
          <b-tooltip
            type="is-light"
            :triggers="['click']"
            :auto-close="['outside', 'escape']"
            multilined
            size="is-large"
          >
            <template v-slot:content>
              <div class="has-text-centered">
                <div class="pt-3 is-size-6">{{ step.attributes.epic_fail }}</div>
                <div v-if="step.attributes.epic_fail_image.url" class="p-3 m-3">
                  <figure class="image is-inline-block">
                    <img
                      style="border-radius: 5%"
                      :src="step.attributes.epic_fail_image.url"
                      alt="Epic fail image"
                    />
                  </figure>
                </div>
                <div v-else class="pb-3"></div>
              </div>
            </template>
            <a><b-icon type="is-brown" icon="emoticon-poop"></b-icon></a>
          </b-tooltip>
        </span>
        <span v-else>
          <b-icon type="is-gray" icon="emoticon-poop"></b-icon>
        </span>
      </template>
    </carousel-vertical>
  </section>
</template>

<script>
import CarouselVertical from '@/components/concerns/Images/CarouselVertical'
export default {
  props: ['step', 'images'],
  components: {
    CarouselVertical
  }
}
</script>
